export const TasksApiUrls = {
  tasks: '/tasks',
  careHomeTasks: '/care-homes/$chId/tasks',
  taskBoards: '/task-boards',
  templateTasks: '/tasks/template',
};
